import {Parameter, ConfigParamRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {Typography} from "@mui/material";
import {TableCell} from "@mui/material";
import {useApiManager} from "../../../../components/utils/api";

export const ParamListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<Parameter> = {
		title: "Parámetros ",
		onClick: "/app/admin/config/param",
		headers: [
			{title: "Nombre"},
			{title: "Valor"},
			{title: "Descripción"}
		],
		decorator: (bean: Parameter) => (
			< >
				<TableCell sx={{fontFamily: "monospace", fontSize: 13}}>
					{bean.name}
				</TableCell>
				<TableCell>
					<Typography variant="body2" noWrap title={bean.value} sx={{fontFamily: "monospace", fontSize: 13}}>
						{bean.value || "—"}
					</Typography>
				</TableCell>
				<TableCell sx={{minWidth: 240, maxWidth: 520}}>
					<Typography variant="body2" color={bean.description ? "text.secondary" : "text.disabled"}>
						{bean.description || "—"}
					</Typography>
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			const ctrl = apiManager.factory(ConfigParamRestControllerApiFactory);
			return ctrl.pageParameter(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};